import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, FormStore, IFormField, inject, Input, toArray } from 'Mri.Web.Common';
import * as React from 'react';
import { FormGroup, Input as BootstrapInput } from 'reactstrap';
import { NocServersStore } from '../../../NocServers/NocServersStore';
import { AccountStore } from '../../../Account/AccountStore';

export interface IDisplayFormConnectionProps {
    readonly displayForm: FormStore<Mri.Web.Internal.Controllers.Displays.UpdateDisplayModel>;
    readonly displayLoginPoll: Mri.DisplaySystem.DisplayLoginPoll;
}

@autoinject
@observer
export class DisplayFormConnection extends React.Component<IDisplayFormConnectionProps> {
    public render() {
        const fields = this.props.displayForm.fields.displayConnectionData.fields;

        return (
            <>
                <div className="col-12">
                    <hr />

                    <h3>Connection</h3>

                    <FormGroup color={fields.active.state}>
                        <Input type="checkbox" field={fields.active} className="ms-1" />
                        <span>Active Connection</span>
                    </FormGroup>
                </div>

                {fields.active.value && (
                    <>
                        <div className="col-12">
                            <div className="row">
                                <div className="col-md-3">
                                    <FormGroup color={fields.displayBoardIP.state}>
                                        <label className="control-label">Display IP</label>
                                        <div>
                                            <Input
                                                type="text"
                                                field={fields.displayBoardIP}
                                                placeholder="192.168.3.3"
                                            />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup color={fields.nocServer.state}>
                                        <label className="control-label">NOC Server</label>
                                        <div>
                                            <Input type="select" field={fields.nocServer}>
                                                <option value=""> None </option>
                                                {toArray(this.nocServersStore.nocServers).map(n => (
                                                    <option key={n.serverName}>{n.serverName}</option>
                                                ))}
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-2">
                                    <FormGroup color={fields.displayBoardPort.state}>
                                        <label className="control-label">Board Port</label>
                                        <div>
                                            <Input type="text" field={fields.displayBoardPort} placeholder="7100" />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-2">
                                    <FormGroup color={fields.displayBoardWebsitePort.state}>
                                        <label className="control-label">Web Port</label>
                                        <div>
                                            <Input
                                                type="text"
                                                field={fields.displayBoardWebsitePort}
                                                placeholder="443"
                                            />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-2">
                                    <FormGroup color={fields.sslPort.state}>
                                        <label className="control-label">SSL Port</label>

                                        <div>
                                            <Input type="text" field={fields.sslPort} placeholder="22" />
                                        </div>
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <FormGroup color={fields.input1IP.state}>
                                        <label className="control-label">Player 1 IP Address</label>
                                        <div>
                                            <Input type="text" field={fields.input1IP} placeholder="192.168.3.4:5970" />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup color={fields.input1Password.state}>
                                        <label className="control-label">Password</label>
                                        <div>
                                            <Input
                                                type="text"
                                                max={50}
                                                field={fields.input1Password}
                                                className={this.showPlayer1Password ? '' : 'text-password'}
                                                placeholder="********"
                                            />
                                            <BootstrapInput
                                                type="checkbox"
                                                onChange={action(
                                                    () => (this.showPlayer1Password = !this.showPlayer1Password)
                                                )}
                                                className="ms-2"
                                            />
                                            {this.showPlayer1Password ? (
                                                <label>Hide password</label>
                                            ) : (
                                                <label>Show password</label>
                                            )}
                                        </div>
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <FormGroup color={fields.input2IP.state}>
                                        <label className="control-label">Player 2 IP Address</label>
                                        <div>
                                            <Input type="text" field={fields.input2IP} placeholder="192.168.3.5:3380" />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup color={fields.input2Password.state}>
                                        <label className="control-label">Password</label>
                                        <div>
                                            <Input
                                                type="text"
                                                max={50}
                                                field={fields.input2Password}
                                                className={this.showPlayer2Password ? '' : 'text-password'}
                                                placeholder="********"
                                            />
                                            <BootstrapInput
                                                type="checkbox"
                                                onChange={action(
                                                    () => (this.showPlayer2Password = !this.showPlayer2Password)
                                                )}
                                                className="ms-2"
                                            />

                                            {this.showPlayer2Password ? (
                                                <label>Hide password</label>
                                            ) : (
                                                <label>Show password</label>
                                            )}
                                        </div>
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <FormGroup color={fields.cameraIP.state}>
                                        <label className="control-label">Camera IP</label>
                                        <div>
                                            <Input type="text" field={fields.cameraIP} placeholder="192.168.3.3:8080" />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-md-6">
                                    <FormGroup color={fields.modemIP.state}>
                                        <label className="control-label">Modem IP</label>
                                        <div>
                                            <Input type="text" field={fields.modemIP} placeholder="192.168.3.1" />
                                        </div>
                                    </FormGroup>
                                </div>
                            </div>

                            <hr />
                            <div className="row">
                                <div className="col-md-12">
                                    <h4 className="d-inline-block">Display Web Login</h4>
                                    <a
                                        href={`${this.accountStore.portalUrl}/proxy/${this.props.displayForm?.values?.serialNumber}/private/config?set=1`}
                                        target="_blank"
                                        className="btn btn-link stat-link"
                                    >
                                        Edit Config
                                    </a>
                                </div>
                                <br />
                                <br />
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="control-label">Username:</label>
                                    <div>
                                        <Input field={ {} as IFormField<string> } type="text" value={this.props.displayLoginPoll.username} placeholder="N/A" disabled />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="control-label">Password:</label>
                                    <div>
                                        <Input field={ {} as IFormField<string> } type="text" value={this.props.displayLoginPoll.password} placeholder="N/A" disabled />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }

    @observable
    private showPlayer1Password = false;
    @observable
    private showPlayer2Password = false;
    @inject
    private nocServersStore!: NocServersStore;
    @inject
    private accountStore!: AccountStore;
}
